import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import { MARKETPLACE_CARD_OVERRIDES, MARKETPLACE_CATEGORIES, MARKETPLACE_CHANNELS_V2 } from '../constants'
import { MarketplaceCategories, MarketplaceTabs } from '../Types'
import { useEffect, useState } from 'react'
import { WizardButton, WizardCard } from '../WizardButton/WizardButton'
import { WizardCategoryCardGrid } from '../WizardCategoryCard/WizardCategoryCard'

export const Marketplace = (props: SectionProps) => {
  const subCategory = props.subCategory as MarketplaceCategories
  const setSubCategory = props.setSubCategory

  const [selectedTab] = useState<MarketplaceTabs>('all')

  useEffect(() => {
    props.searchRef?.current?.focus()
  }, [selectedTab, props.searchRef])

  if (subCategory) {
    return (
      <div className={Styles.commonSectionContainer}>
        <WizardCategoryCardGrid
          heading={`Which platform do you want to create ${subCategory === 'visual' ? 'visuals' : 'copy'} for?`}
        >
          {MARKETPLACE_CHANNELS_V2[subCategory].map((channel) => (
            <WizardButton
              key={channel}
              channelKey={channel}
              version={2}
              size="md"
              cardInfoOverride={MARKETPLACE_CARD_OVERRIDES}
              {...props}
            />
          ))}
        </WizardCategoryCardGrid>
      </div>
    )
  }

  return (
    <div className={Styles.commonSectionContainer}>
      <WizardCategoryCardGrid heading="What kind of marketplace content would you like to create?">
        {MARKETPLACE_CATEGORIES.map((category) => (
          <WizardCard
            size="wide"
            key={category.name}
            title={category.label}
            description={category.description}
            image={category.image}
            onPress={() => setSubCategory(category.name)}
            {...props}
          />
        ))}
      </WizardCategoryCardGrid>
    </div>
  )
}
